//@flow
import {
  endpoints,
  createQuickReplyEndpoint,
  deleteQuickReplyEndpoint,
  editQuickReplyEndpoint,
  getQuickRepliesEndpoint,
  getQuickReplyEndpoint,
} from './api';

import type {
  PaginationResponse,
  PaginationRequest,
  QuickReply,
  QuickReplyRequest,
} from '../../../entities';
import {buildRoute} from '../../../http';

const defaultPagination = {page: 0, size: 10};

export type ListQuickReplyRequest = {
  name?: string,
} & PaginationRequest;

export function getQuickRepliesService(
  pagination?: ListQuickReplyRequest = defaultPagination
): Promise<PaginationResponse<QuickReply>> {
  const paginationParams = {
    page: pagination.page.toString(),
    size: pagination.size.toString(),
    name: pagination.name || undefined,
  };

  return getQuickRepliesEndpoint(paginationParams).toPromise();
}

export function createQuickReplyService(
  quickReply: QuickReplyRequest
): Promise<QuickReply> {
  return createQuickReplyEndpoint(quickReply).toPromise();
}

export function editQuickReplyService(
  quickReplyId: string,
  quickReply: QuickReplyRequest
): Promise<QuickReply> {
  const route = buildRoute(endpoints.EDIT_QUICK_REPLY, [quickReplyId]);

  return editQuickReplyEndpoint(quickReply, {route}).toPromise();
}

export function deleteQuickReplyService(quickReplyId: string): Promise<void> {
  const route = buildRoute(endpoints.DELETE_QUICK_REPLY, [quickReplyId]);

  return deleteQuickReplyEndpoint({route}).toPromise();
}

export function getQuickReplyByIdService(
  quickReplyId: string
): Promise<QuickReply> {
  const route = buildRoute(endpoints.GET_QUICK_REPLY, [quickReplyId]);

  return getQuickReplyEndpoint({route}).toPromise();
}
